import { get } from 'lodash';
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import { Button, Grid } from '@mui/material';
import UserAPI from '../../Lib/Api/user';

export default function ReceivingPackingListUpload(props) {
  const { perms = {} } = props;
  const [error, setError] = useState(null);
  const [uploadFile, setUploadFile] = useState(
    !get(props.order, 'receiving_packing_list.exists'),
  );
  const [uploading, setUploading] = useState(false);
  const { canReadPackingList = true, canUpdatePackingList = true } = perms;

  function onUpload(e) {
    const url = get(props.order, 'receiving_packing_list.write');
    setUploading(true);

    axios({
      method: 'put',
      url,
      data: e.target.files[0],
      headers: {
        'Content-Type': 'application/pdf',
      },
    })
      .then(async (results) => {
        await UserAPI.updatePDFTimestamp(
          props.currentUser.id,
          props.order.po_number,
          'packing_list_receiver_timestamp',
        );
        setUploadFile(false);
        props.onUpload(results);
      })
      .catch((err) => setError(err.msg))
      .finally(() => setUploading(false));
  }

  /**
   * If there is a link on the file input- i.e. if there is a file uploaded and a url passed to the input as a prop, open the file in a new window.
   */
  const download = () => {
    window.open(get(props.order, 'receiving_packing_list.read'));
  };

  return (
    <Grid>
      {uploadFile ? (
        <input
          disabled={uploading || !canUpdatePackingList}
          type="file"
          onChange={onUpload}
        />
      ) : (
        <Grid container>
          {canReadPackingList && (
            <Button
              variant="outlined"
              color="primary"
              size="small"
              onClick={download}
            >
              Download
            </Button>
          )}
          {canUpdatePackingList && (
            <Button
              style={{ marginLeft: '12px' }}
              variant="contained"
              color="primary"
              size="small"
              onClick={() => setUploadFile(true)}
            >
              Replace
            </Button>
          )}
        </Grid>
      )}

      {error && (
        <Grid item style={{ color: 'red' }}>
          {error}
        </Grid>
      )}
    </Grid>
  );
}

ReceivingPackingListUpload.propTypes = {
  order: PropTypes.shape({}).isRequired,
  onUpload: PropTypes.func.isRequired,
  currentUser: PropTypes.shape({}).isRequired,
  perms: PropTypes.shape({
    canUpdatePackingList: PropTypes.bool,
    canReadPackingList: PropTypes.bool,
  }).isRequired,
};
